// extracted by mini-css-extract-plugin
module.exports = {"container":"_d67da38","button":"_4978201","text":"_61437c8","isExpanded":"_6717d35"};